export default {
  pt: {
    introQuestion: "Está com dificuldades para encontrar sua bike?",
    introYes: "Sim, preciso de ajuda",
    introNo: "Não",
    brandQuestion: "Sua bike é da marca {brand}?",
    brandYes: "Sim",
    brandNo: "Não",
    brandWrongTitle: "Sem problemas!",
    brandWrongMultibrandDescription:
      "Você pode voltar e escolher a marca correta da sua bike, ou falar com o nosso suporte.",
    brandWrongOwnBrandDescription:
      "Este link de contratação é específico da marca {brand}. Se sua bike é de outra marca, você pode ter entrado pelo link errado.",
    brandWrongOwnBrandSupportLine: "Fale com o nosso suporte para te ajudar.",
    closeButton: "Fechar",
    brandWrongBackToSelectBrand: "Escolher marca novamente",
    brandWrongTalkToSupport: "Falar com o suporte",
    brandWrongCancel: "Cancelar",
    notFoundButton: "Não encontrei mesmo assim",
    categoryTitle: "Qual a categoria da sua bike?",
    categoryLabel: "Categoria",
    finalTitle: "Conte pra gente sobre sua bike",
    finalDescription: "Um consultor vai analisar as informações e entrar em contato com você.",
    modelLabel: "Modelo da bike",
    valueLabel: "Valor de novo da bike",
    valueTooltip:
      "Valor de novo é o valor de uma bike nova do mesmo modelo. O valor do seu seguro leva esse valor em consideração.",
    submitButton: "Enviar",
    backButton: "Voltar",
    modelRequired: "Informe o modelo da bike.",
    valueRequired: "Informe o valor aproximado da bike.",
    reportErrorTitle: "Erro ao enviar",
    reportErrorDescription: "Não foi possível enviar os dados da sua bike. Tente novamente.",
    supportWhatsAppTextMultibrand:
      "Olá! Entrei na jornada de contratação do seguro, mas percebi que selecionei a marca errada da minha bike. Pode me ajudar a corrigir isso?",
    supportWhatsAppTextOwnBrand:
      "Olá! Entrei na jornada de seguro da marca {brand}, mas minha bike não é dessa marca. Acho que entrei pelo link errado. Pode me ajudar?",
  },

  en: {
    introQuestion: "Are you having trouble finding your bike?",
    introYes: "Yes, I need help",
    introNo: "No",
    brandQuestion: "Is your bike a {brand}?",
    brandYes: "Yes",
    brandNo: "No",
    brandWrongTitle: "No worries!",
    brandWrongMultibrandDescription:
      "You can go back and choose the correct brand for your bike, or talk to our support team.",
    brandWrongOwnBrandDescription:
      "This contracting link is specific to the {brand} brand. If your bike is from a different brand, you may have used the wrong link.",
    brandWrongOwnBrandSupportLine: "Talk to our support team for help.",
    closeButton: "Close",
    brandWrongBackToSelectBrand: "Choose brand again",
    brandWrongTalkToSupport: "Talk to support",
    brandWrongCancel: "Cancel",
    notFoundButton: "I still can't find it",
    categoryTitle: "What category is your bike?",
    categoryLabel: "Category",
    finalTitle: "Tell us about your bike",
    finalDescription: "A consultant will review the information and reach out to you.",
    modelLabel: "Bike model",
    valueLabel: "New bike value",
    valueTooltip:
      "The new bike value is the price of a brand-new bike of the same model. Your insurance price takes this value into account.",
    submitButton: "Send",
    backButton: "Back",
    modelRequired: "Enter the bike model.",
    valueRequired: "Enter the approximate bike value.",
    reportErrorTitle: "Error sending",
    reportErrorDescription: "We couldn't send your bike's details. Please try again.",
    supportWhatsAppTextMultibrand:
      "Hi! I started the insurance journey, but I realized I selected the wrong brand for my bike. Can you help me fix that?",
    supportWhatsAppTextOwnBrand:
      "Hi! I started the {brand} insurance journey, but my bike isn't from that brand. I think I used the wrong link. Can you help me?",
  },
};
